import { React, useEffect, useState } from "react";
import {
  Button,
  Divider,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { read, readFile, utils } from "xlsx";
import AppButton from "../../../../../base/AppButton.component";
import { InputValidation } from "../../../../../../utils/InputValidationRegex";
import { DialogStyle } from "./Dialog.styles";
import { GET_CALL_COUNT } from "../../../../../../graphql/query/query"; // ✅ CHANGED - import the query
import { useAuth } from "../../../../../../context/Auth.context";
import { useParams } from "react-router-dom";
import { useAppContext } from "../../../../../../context/App.context";
import { useMutation, useQuery } from "@apollo/client";
import {
  CREATE_USER,
  IMPORT_USERS,
  UPDATE_USER,
} from "../../../../../../graphql/mutation/mutation";
import { CheckCircle, CloudUpload, Download } from "@mui/icons-material";
import {
  firstOfMonth,
  today,
  userTemplateURL,
} from "../../../../../../utils/Utils";
import moment from "moment";

let importUser = [];
const INITIAL_FILTER = {
  startDate: moment(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  ).format("MM/DD/YYYY"),
  endDate: moment(new Date()).format("MM/DD/YYYY"),
};

const ImportUserDialog = (props) => {
  const theme = useTheme();
  const auth = useAuth();
  const params = useParams();
  const app = useAppContext();
  const [isSaved, setSaved] = useState(false);
  const [filterData, setFilterData] = useState(INITIAL_FILTER);

  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    designation: "manager",
    receiveNotification: 3,
    verifyNotification: 3,
    appointmentNotification: 3,
    reviewNotification: 3,
    referralNotification: 3,
    knowledgeHubNotification: 3,
    csiNotification: 3,
    prequalNotification: 3,
    idVerificationNotification: 3,
    appDownloadNotification: 3,
    fileName: "",
    file: null,
    verification_workflow_id: 1,
  });

  const [createUser, { loading: createLoading, data: createdUser }] =
    useMutation(CREATE_USER);
  const [updateUser, { loading: updateLoading, data: updatedUser }] =
    useMutation(UPDATE_USER);
const [importUsers, { loading: importLoading, data: UsersImport }] =
  useMutation(IMPORT_USERS, {
    refetchQueries: [
      {
        query: GET_CALL_COUNT,
        variables: {
          callInput: {
            d_startDate: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format("YYYY-MM-DD"),
            d_endDate: moment(new Date()).format("YYYY-MM-DD"),
            dealership_id: params.dealershipId,
            timezone: new Date().getTimezoneOffset(),
            isAdmin: true,
          },
        },
      },
    ],
    awaitRefetchQueries: true,
  });

  const { update, edit = false } = props;

  const handleFileSelection = async (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      const fileName = selectedFile.name;
      setUser({ ...user, fileName: fileName });
      reader.readAsBinaryString(selectedFile);
      reader.onload = async (e) => {
        const fileData = e.target.result;
        const workbook = read(fileData, { type: "binary" });
        const sheetName = workbook.SheetNames[1];
        const worksheet = workbook.Sheets[sheetName];

        let data = utils.sheet_to_json(worksheet, { header: 1 });
        data.shift();
        data = data.filter((element) => {
          return element && element.length > 0 && element[1] && element[1].toString().trim() !== '';
        });
        data.forEach((element) => {
          let newUser = {
            first_name: "",
            last_name: "",
            email: "",
            mobile_number: "",
            role: "",
            verification_preference: "",
            appointment_preference: "",
            notification_preference: "",
            review_preference: "",
            referral_preference: "",
            knowledge_hub_preference: "",
            csi_preference: "",
            prequal_preference: "",
            id_verification_preference: "",
            app_download_preference: "",
            created_by: auth.user.user_id,
            updated_by: auth.user.user_id,
            dealership_id: params.dealershipId,
            employee_user_id: null,
            d_startDate: firstOfMonth,
            d_endDate: today,
            f_startDate: firstOfMonth,
            f_endDate: today,
            timezone: new Date().getTimezoneOffset(),
            verification_workflow_id: "1",
            isAdmin: true,
          };

          newUser = {
            ...newUser,
            first_name: element[1] || "",
            last_name: element[2] || "",
            email: element[3] || "",
            mobile_number: element[4] || "",
            role: element[5] === "MANAGER" ? "manager" : element[5] === "EMPLOYEE" ? "employee" : "",
            verification_workflow_id:
              element[6] == "OFFER QUOTE ONLY"
                ? 3
                : element[6] == "VERIFY ONLY"
                  ? 2
                  : 1,
            verification_preference:
              element[7] == "EMAIL" ? 1 : element[7] == "TEXT" ? 2 : 3,
            notification_preference:
              element[8] == "EMAIL" ? 1 : element[8] == "TEXT" ? 2 : 3,
            review_preference:
              element[9] == "EMAIL" ? 1 : element[9] == "TEXT" ? 2 : 3,
            appointment_preference:
              element[10] == "EMAIL" ? 1 : element[10] == "TEXT" ? 2 : 3,
            referral_preference:
              element[11] == "EMAIL" ? 1 : element[11] == "TEXT" ? 2 : 3,
            knowledge_hub_preference:
              element[12] == "EMAIL" ? 1 : element[12] == "TEXT" ? 2 : 3,
            csi_preference:
              element[13] == "EMAIL" ? 1 : element[13] == "TEXT" ? 2 : 3,
            prequal_preference:
              element[14] == "EMAIL" ? 1 : element[14] == "TEXT" ? 2 : 3,
            id_verification_preference:
              element[15] == "EMAIL" ? 1 : element[15] == "TEXT" ? 2 : 3,
            app_download_preference:
              element[16] == "EMAIL" ? 1 : element[16] == "TEXT" ? 2 : 3,
          };

          importUser.push(newUser);
        });
      };
    }
  };

  useEffect(() => {
    if (update) {
      setUser({
        firstName: update.first_name,
        lastName: update.last_name,
        email: update.email,
        mobileNumber: update.mobile_number,
        designation: update.role,
        receiveNotification: update.notification_preference,
        verifyNotification: update.verification_preference,
        appointmentNotification: update.appointment_preference,
        reviewNotification: update.review_preference,
        referralNotification: update.referral_preference,
        knowledgeHubNotification: update.knowledge_hub_preference,
        csiNotification: update.csi_preference,
        prequalNotification: update.prequal_preference,
        idVerificationNotification: update.id_verification_preference,
        appDownloadNotification: update.app_download_preference,
        userId: update.employee_user_id,
        verification_workflow_id: update?.verification_workflow_id,
      });
    }
  }, [update]);

  useEffect(() => {
    if (createdUser) setSaved(true);
    if (updatedUser) setSaved(true);
    if (UsersImport) {
      setSaved(true);
      importUser = []; // ✅ CHANGED - reset importUser array after successful import
    }
  }, [createdUser, updatedUser, setSaved, UsersImport]);

  const createUserHandler = () => {
    if (user.fileName) {
      if (importUser.length > 0)
        importUsers({
          variables: {
            importInput: {
              dealership_id: params.dealershipId,
              users: importUser,
            },
          },
        });
    } else {
      createUser({
        variables: {
          createUserInput: {
            first_name: user.firstName,
            last_name: user.lastName,
            email: user.email,
            mobile_number: user.mobileNumber.replace(/\D/g, ""),
            role: user.designation,
            notification_preference: user.receiveNotification,
            verification_preference: user.verifyNotification,
            appointment_preference: user.appointmentNotification,
            review_preference: user.reviewNotification,
            referral_preference: user.referralNotification,
            knowledge_hub_preference: user.knowledgeHubNotification,
            csi_preference: user.csiNotification,
            prequal_preference: user.prequalNotification,
            id_verification_preference: user.idVerificationNotification,
            app_download_preference: user.appDownloadNotification,
            created_by: auth.user.user_id,
            updated_by: auth.user.user_id,
            dealership_id: params.dealershipId,
            employee_user_id: null,
            d_startDate: firstOfMonth,
            d_endDate: today,
            f_startDate: firstOfMonth,
            f_endDate: today,
            timezone: new Date().getTimezoneOffset(),
            is_active: true,
            verification_workflow_id: user?.verification_workflow_id,
            isAdmin: true,
          },
        },
      });
    }
  };

  const updateUserHandler = () => {
    updateUser({
      variables: {
        createUserInput: {
          user_id: user.userId,
          first_name: user.firstName,
          last_name: user.lastName,
          email: user.email,
          mobile_number: user.mobileNumber.replace(/\D/g, ""),
          notification_preference: user.receiveNotification,
          verification_preference: user.verifyNotification,
          appointment_preference: user.appointmentNotification,
          review_preference: user.reviewNotification,
          referral_preference: user.referralNotification,
          knowledge_hub_preference: user.knowledgeHubNotification,
          csi_preference: user.csiNotification,
          prequal_preference: user.prequalNotification,
          id_verification_preference: user.idVerificationNotification,
          app_download_preference: user.appDownloadNotification,
          role: user.designation,
          created_by: auth.user.user_id,
          updated_by: auth.user.user_id,
          dealership_id: params.dealershipId,
          employee_user_id: null,
          d_startDate: firstOfMonth,
          d_endDate: today,
          f_startDate: firstOfMonth,
          f_endDate: today,
          timezone: new Date().getTimezoneOffset(),
          is_active: true,
          verification_workflow_id: user?.verification_workflow_id,
          isAdmin: true,
        },
      },
    });
  };

  return (
    <>
      <Divider />
      <Box sx={{ p: "16px" }}>
        {!edit && (
          <>
            {/* ── NEW DRAG & DROP UPLOAD ZONE ── */}
            <Box>
              <FormControl variant="outlined" sx={DialogStyle.excel}>
                <Box
                  sx={{
                    border: `2px dashed ${theme.palette.primary.main}`,
                    borderRadius: 1,
                    p: 3,
                    height: 350,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.dataTransfer.dropEffect = "copy";
                  }}
                  onDragEnter={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.currentTarget.style.border = `2px dashed ${theme.palette.primary.main}`;
                    e.currentTarget.style.backgroundColor =
                      theme.palette.primary.light + "20";
                    e.currentTarget.style.transform = "scale(1.02)";
                    e.currentTarget.style.transition = "all 0.2s ease";
                  }}
                  onDragLeave={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const relatedTarget = e.relatedTarget;
                    if (!e.currentTarget.contains(relatedTarget)) {
                      e.currentTarget.style.border = `2px dashed ${theme.palette.grey[400]}`;
                      e.currentTarget.style.backgroundColor =
                        theme.palette.grey[50];
                      e.currentTarget.style.transform = "scale(1)";
                    }
                  }}
                  onDrop={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    e.currentTarget.style.border = `2px dashed ${theme.palette.grey[400]}`;
                    e.currentTarget.style.transform = "scale(1)";

                    const files = e.dataTransfer.files;
                    if (files && files.length > 0) {
                      e.dataTransfer.clearData();
                      for (let i = 0; i < files.length; i++) {
                        const file = files[i];
                        const validTypes = [
                          "application/vnd.ms-excel",
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        ];
                        const fileExtension = file.name
                          .split(".")
                          .pop()
                          .toLowerCase();
                        const isValidType =
                          validTypes.includes(file.type) ||
                          ["xls", "xlsx"].includes(fileExtension);

                        if (isValidType) {
                          const mockEvent = { target: { files: [file] } };
                          if (handleFileSelection) {
                            handleFileSelection(mockEvent);
                          }
                          break;
                        } else if (i === files.length - 1) {
                          alert("Please upload only Excel files (.xls, .xlsx)");
                        }
                      }
                    }
                  }}
                  onClick={() => {
                    const fileInput =
                      document.getElementById("raised-button-file");
                    if (fileInput) fileInput.click();
                  }}
                >
                  <CloudUpload
                    sx={{
                      fontSize: 48,
                      color: theme.palette.grey[400],
                      mb: 2,
                      transition: "color 0.2s ease",
                    }}
                  />

                  <Typography variant="h6" gutterBottom textAlign="center">
                    {user?.fileName
                      ? user?.fileName
                      : "Drag & drop Excel file here"}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="textSecondary"
                    gutterBottom
                    textAlign="center"
                  >
                    or
                  </Typography>

                  <Button
                    variant="contained"
                    component="span"
                    sx={{ mt: 1 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      const fileInput =
                        document.getElementById("raised-button-file");
                      if (fileInput) fileInput.click();
                    }}
                  >
                    Browse Files
                  </Button>

                  <Typography
                    variant="caption"
                    color="textSecondary"
                    sx={{ display: "block", mt: 2, textAlign: "center" }}
                  >
                    Supported formats: .xls, .xlsx
                  </Typography>

                  {/* Hidden file input */}
                  <input
                    accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    style={{ display: "none" }}
                    id="raised-button-file"
                    type="file"
                    onChange={handleFileSelection}
                  />
                </Box>
              </FormControl>
            </Box>
            {/* ── END DRAG & DROP UPLOAD ZONE ── */}

            <Box sx={DialogStyle.import}>
              <Button href={userTemplateURL} startIcon={<Download />}>
                Download Template
              </Button>
            </Box>
          </>
        )}
      </Box>

      <Box>
        {(createdUser?.createUser?.errors ||
          updatedUser?.updateUser?.errors) && (
          <Typography
            variant="body2"
            style={{ textAlign: "center", color: "red" }}
          >
            {createdUser?.createUser?.errors
              ? createdUser?.createUser?.errors[0].message
              : updatedUser?.updateUser?.errors[0].message}
          </Typography>
        )}
      </Box>

      <Divider />

      <Box sx={DialogStyle.button}>
        {createdUser?.createUser?.dealership_id ||
        updatedUser?.updateUser?.dealership_id ||
        UsersImport?.importUsers?.status ? (
          <Box sx={{ display: "flex", my: "14px" }}>
            <CheckCircle color={"primary"} />
            <span
              style={{ color: theme.palette.primary.main, marginLeft: "4px" }}
            >
              SUCCESS
            </span>
          </Box>
        ) : (
          <AppButton
            buttonText={edit ? "Update" : "Create"}
            clickHandler={edit ? updateUserHandler : createUserHandler}
            size="medium"
            variant="contained"
            sx={{ width: "50%", my: 1 }}
            disabled={
              user.fileName
                ? false
                : createLoading ||
                  updateLoading ||
                  importLoading ||
                  user.firstName === "" ||
                  user.lastName === "" ||
                  user.email === "" ||
                  user.mobileNumber === "" ||
                  InputValidation.nameValidation(user.firstName) ||
                  InputValidation.nameValidation(user.lastName) ||
                  InputValidation.numberValidation(user.mobileNumber) ||
                  InputValidation.emailValidation(user.email)
            }
            loading={createLoading || updateLoading || importLoading}
          />
        )}
      </Box>
    </>
  );
};

export default ImportUserDialog;